import { NgModule } from '@angular/core';

import { PcgEntryFormComponent } from '@modules/shared/forms/pcg-entry-form/pcg-entry-form.component';
import { SharedModule } from '@modules/shared/shared.module';
import { CreatePcgEntryDialogComponent } from '@shared-dialogs/create-pcg-entry-dialog/create-pcg-entry-dialog.component';

@NgModule({
  declarations: [CreatePcgEntryDialogComponent],
  imports: [SharedModule, PcgEntryFormComponent]
})
export class CreatePcgEntryDialogModule {}
